import { Collapse, Divider, Hidden } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Toolbar from '@material-ui/core/Toolbar';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { AccountBalanceWalletOutlined, Apps, BlurCircular, CastOutlined, ExpandLess, ExpandMore, GridOnOutlined, InfoOutlined, NoteAddOutlined, SettingsOutlined, Share, VpnKeyOutlined, LockOutlined, HelpOutline, CodeOutlined, SchoolOutlined, TuneOutlined } from '@material-ui/icons';
import MeetingRoomOutlinedIcon from '@material-ui/icons/MeetingRoomOutlined';
import PlaylistAddOutlinedIcon from '@material-ui/icons/PlaylistAddOutlined';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import AssignmentIndIcon from '@material-ui/icons/AssignmentIndOutlined';
import ContactSupportIcon from '@material-ui/icons/BookOutlined';
import SubscriptionsIcon from '@material-ui/icons/BookmarkBorder';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import CardIcon from '@material-ui/icons/CreditCard';
import DomainsIcon from '@material-ui/icons/Domain';
import CustomersIcon from '@material-ui/icons/GroupOutlined';
import CustomerContractIconCustom from '../../components/CustomerContractIconCustom';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import ProductIcons from '@material-ui/icons/LibraryBooksOutlined';
import PriceListIcon from '@material-ui/icons/LocalAtm';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import MarketplacesIcon from '@material-ui/icons/Storefront';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import { WithStyles } from '@material-ui/styles';
import 'moment/locale/it';
import React from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Permission from '../../components/Permission/Permission';
import ReduxLanguage from '../../components/ReduxLanguage';
import { IState } from '../../redux/store';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { PERMISSIONS, Roles } from '../../services/PermissionService/PermissionConstants';
import AppHeader from './AppHeader';

const drawerWidth = 220;

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 400,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  content: {
    flexGrow: 1,
  },
  contentWithDrawer: {
    backgroundColor: '#f1f1f1',
    height: 'calc(100vh - 64px)',
    paddingTop: 63,
    marginLeft: drawerWidth,
    overflowX: 'hidden',
    '@media (max-width: 959px)': {
      marginLeft: 0,
    },
  },
  drawerIcon: {
    minWidth: 'fit-content',
    marginRight: 10,
  },
  drawerText: {
    margin: 0,
    fontSize: 14
  }
});

type IReduxProps = WithStyles<typeof styles> & ConnectedProps<typeof connector>;

export interface IDrawerLayoutState {
  mobileOpen: boolean;
  priceListMenuOpen: boolean;
  gatewayListMenuOpen: boolean;
  mksMenuOpen: boolean;
}

export interface IDrawerLayoutProps extends IReduxProps, RouteComponentProps<any> {
  height:number;
}

export class DrawerLayout extends React.Component<IDrawerLayoutProps, IDrawerLayoutState> {

  constructor(props: IDrawerLayoutProps) {
    super(props);
    this.state = {
      mobileOpen: false,
      priceListMenuOpen: false,
      gatewayListMenuOpen: false,
      mksMenuOpen: false,
    };
  }

  handleDrawerToggle() {
    const { mobileOpen } = this.state;
    this.setState({ mobileOpen: !mobileOpen });
  }


  onItemClick(page: string) {
    const { history } = this.props;
    if (history.location.pathname.startsWith('/activation')) {
      history.push('/'+page)
      return
    }
    history.push(page)
  }

  onTogglePriceListMenu() {
    const { priceListMenuOpen } = this.state;
    this.setState({ priceListMenuOpen: !priceListMenuOpen });
  }

  onToggleGatewaysListMenu() {
    const { gatewayListMenuOpen } = this.state;
    this.setState({ gatewayListMenuOpen: !gatewayListMenuOpen });
  }

  onToggleMksMenu() {
    const { mksMenuOpen } = this.state;
    this.setState({ mksMenuOpen: !mksMenuOpen });
  }

  render() {
    const { children, classes, history, userEmail } = this.props;
    const { mobileOpen, priceListMenuOpen, gatewayListMenuOpen, mksMenuOpen } = this.state;
    const currentLocation = (history.location.pathname).replace('/', '');
    const isSofiaAdmin = AbilityProvider.getAbilityHelper().hasRoles([Roles.ROLE_VASHO_SOFIA_ADMIN]);

    const drawerContent = (
      <div className={classes.drawerContainer}>
        <List>
        <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_ISEO_SALES_APPS}>
          <>
            <ListItem selected={currentLocation === 'iseoSalesApps'} button key={'iseoSalesApps'} onClick={() => this.onItemClick('iseoSalesApps')} style={{ backgroundColor: '#5AC0B1' }}>
              <ListItemIcon className={classes.drawerIcon}><Apps style={{ fontSize: 20, color: 'white' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ color: 'white', fontWeight: currentLocation === 'iseoSalesApps' ? 'bold' : 'normal'}}
                  >
                    {'ISEO Sales Apps'}
                  </h3>
                }
              />
            </ListItem>
            <Divider />
          </>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_ISEO_TRAINING_MATERIALS}>
            <>
              <ListItem selected={currentLocation === 'iseoTrainingMaterials'} button key={'iseoTrainingMaterials'} onClick={() => this.onItemClick('iseoTrainingMaterials')} style={{ backgroundColor: '#e35e5e' }}>
                <ListItemIcon className={classes.drawerIcon}><SchoolOutlined style={{ fontSize: 20, color: currentLocation === 'iseoTrainingMaterials' ? 'white' : 'white' }} /></ListItemIcon>
                <ListItemText
                  primary={
                    <h3
                      className={classes.drawerText}
                      style={{ color: 'white', fontWeight: currentLocation === 'iseoTrainingMaterials' ? 'bold' : 'normal'}}
                    >
                      ISEO Trainings
                    </h3>
                  }
                />
              </ListItem>
              <Divider />
            </>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_VAR_HOMEPAGE}>
            <ListItem selected={currentLocation === 'varHome'} button key={'varHome'} onClick={() => this.onItemClick('varHome')}>
              <ListItemIcon className={classes.drawerIcon}><HomeOutlinedIcon style={{ fontSize: 22, color: currentLocation === 'varHome' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'varHome' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='vars.varHome' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_CUSTOMERS}>
            <ListItem selected={currentLocation === 'customers'} button key={'customers'} onClick={() => this.onItemClick('customers')}>
              <ListItemIcon className={classes.drawerIcon}><CustomersIcon style={{ fontSize: 22, color: currentLocation === 'customers' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'customers' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='login.customers' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_VAR_MANAGEMENT}>
            <ListItem selected={currentLocation === 'vars'} button key={'vars'} onClick={() => this.onItemClick('vars')}>
              <ListItemIcon className={classes.drawerIcon}><AssignmentIndIcon style={{ fontSize: 20, color: currentLocation === 'vars' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'vars' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='vars.varsManagement' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_DOMAINS}>
            <ListItem selected={currentLocation === 'domains'} button key={'domains'} onClick={() => this.onItemClick('domains')}>
              <ListItemIcon className={classes.drawerIcon}><DomainsIcon style={{ fontSize: 20, color: currentLocation === 'domains' ? '#3f3f3f' : 'inherit' }}/></ListItemIcon>
              <ListItemText
                  primary={
                    <h3
                      className={classes.drawerText}
                      style={{ fontWeight: currentLocation === 'domains' ? 'bold' : 'normal'}}
                    >
                      <ReduxLanguage languageKey='domains.luckeyDomainsTitle' />
                    </h3>
                  }
                />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.DOMAIN_DEMO_READ}>
            <ListItem selected={currentLocation === 'demoDomains'} button key={'domains'} onClick={() => this.onItemClick('demoDomains')}>
              <ListItemIcon className={classes.drawerIcon}><DomainsIcon style={{ fontSize: 20, color: currentLocation === 'demoDomains' ? '#3f3f3f' : 'inherit' }}/></ListItemIcon>
              <ListItemText
                  primary={
                    <h3
                      className={classes.drawerText}
                      style={{ fontWeight: currentLocation === 'demoDomains' ? 'bold' : 'normal' }}
                    >
                      <ReduxLanguage languageKey={isSofiaAdmin ? 'demoSystem.demoSystemsTitle' : 'demoSystem.title' } />
                    </h3>
                  }
                />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_MKS}>
            <ListItem button key={'mks'} onClick={() => this.onToggleMksMenu()}>
               <ListItemIcon className={classes.drawerIcon}><LockOutlined style={{ fontSize: 20 }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                  >
                    <ReduxLanguage languageKey='mks.mksTitle' />
                  </h3>
                }
              />
              {mksMenuOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
          </Permission>
          <Collapse in={mksMenuOpen} timeout="auto" unmountOnExit>
            <ListItem style={{ paddingLeft: 25 }} selected={currentLocation === 'relationsMatrix'} button key={'relationsMatrix'} onClick={() => this.onItemClick('relationsMatrix')}>
              <ListItemIcon className={classes.drawerIcon}><GridOnOutlined style={{ fontSize: 18, color: currentLocation === 'relationsMatrix' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'relationsMatrix' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='mks.relationsMatrixTitle' />
                  </h3>
                }
              />
            </ListItem>
            <ListItem style={{ paddingLeft: 25 }} selected={currentLocation === 'cylinders'} button key={'cylinders'} onClick={() => this.onItemClick('cylinders')}>
              <ListItemIcon className={classes.drawerIcon}><MeetingRoomOutlinedIcon style={{ fontSize: 20, color: currentLocation === 'cylinders' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'cylinders' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='mks.cylindersTitle' />
                  </h3>
                }
              />
            </ListItem>
            <ListItem style={{ paddingLeft: 25 }} selected={currentLocation === 'keys'} button key={'keys'} onClick={() => this.onItemClick('keys')}>
              <ListItemIcon className={classes.drawerIcon}><VpnKeyOutlined style={{ fontSize: 20, color: currentLocation === 'keys' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'keys' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='mks.keysTitle' />
                  </h3>
                }
              />
            </ListItem>
            <ListItem style={{ paddingLeft: 25 }} selected={currentLocation === 'imports'} button key={'imports'} onClick={() => this.onItemClick('imports')}>
              <ListItemIcon className={classes.drawerIcon}><CloudUploadOutlinedIcon style={{ fontSize: 20, color: currentLocation === 'imports' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'imports' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='mks.importsTitle' />
                  </h3>
                }
              />
            </ListItem>
          </Collapse>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_MKS}>
            <ListItem selected={currentLocation === 'mksRequests'} button key={'mksRequests'} onClick={() => this.onItemClick('mksRequests')}>
              <ListItemIcon className={classes.drawerIcon}><PlaylistAddOutlinedIcon style={{ fontSize: 20, color: currentLocation === 'mksRequests' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'mksRequests' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='mks.requestsTitle' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_PLANT_ACTIVATIONS}>
            <ListItem selected={currentLocation === 'activationRequests'} button key={'activationRequests'} onClick={() => this.onItemClick('activationRequests')}>
              <ListItemIcon className={classes.drawerIcon}><NoteAddOutlined style={{ fontSize: 20, color: currentLocation === 'activationRequests' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'activationRequests' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='activations.activationRequests' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_RECHARGE_REQUESTS}>
            <ListItem selected={currentLocation === 'rechargeRequests'} button key={'rechargeRequests'} onClick={() => this.onItemClick('rechargeRequests')}>
              <ListItemIcon className={classes.drawerIcon}><CardGiftcardIcon style={{ fontSize: 20, color: currentLocation === 'rechargeRequests' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'rechargeRequests' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='activations.rechargeRequests' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_CARDS}>
            <ListItem style={{}} selected={currentLocation === 'rechargeCards'} button key={'rechargeCards'} onClick={() => this.onItemClick('rechargeCards')}>
              <ListItemIcon className={classes.drawerIcon}><CardIcon style={{ fontSize: 20, color: currentLocation === 'rechargeCards' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'rechargeCards' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='credits.rechargeCards' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_OPPORTUNITIES}>
            <ListItem selected={currentLocation === 'opportunities'} button key={'opportunities'} onClick={() => this.onItemClick('opportunities')}>
              <ListItemIcon className={classes.drawerIcon}><MonetizationOnOutlinedIcon style={{ fontSize: 22, color: currentLocation === 'opportunities' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'opportunities' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='vars.opportunities' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_CONTRACTS}>
            <ListItem selected={currentLocation === 'contracts'} button key={'contracts'} onClick={() => this.onItemClick('contracts')}>
              <ListItemIcon className={classes.drawerIcon}><CustomerContractIconCustom className="" style={{ width: 22, height: 22, color: currentLocation === 'contracts' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'contracts' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='credits.contracts' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_CONTRACT_SERVICES}>
            <ListItem selected={currentLocation === 'contractServices'} button key={'contractServices'} onClick={() => this.onItemClick('contractServices')}>
              <ListItemIcon className={classes.drawerIcon}><LocalOfferOutlinedIcon style={{ fontSize: 20, color: currentLocation === 'contractServices' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'contractServices' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='credits.contractServices' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_ORDERS_STATUS}>
            <ListItem selected={currentLocation === 'activation/wallet'} button key={'activation/wallet'} onClick={() => this.onItemClick('activation/wallet')}>
              <ListItemIcon className={classes.drawerIcon}><AccountBalanceWalletOutlined style={{ fontSize: 20, color: currentLocation === 'activation/wallet' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'activation/wallet' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='activations.walletStatus' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_GATEWAYS}>
            <ListItem button key={'parameters'} onClick={() => this.onToggleGatewaysListMenu()}>
              <ListItemIcon className={classes.drawerIcon}><CastOutlined style={{ fontSize: 20 }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                  >
                    {'HyperGates'}
                  </h3>
                }
              />
              {gatewayListMenuOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
          </Permission>
          <Collapse in={gatewayListMenuOpen} timeout="auto" unmountOnExit>
            <ListItem style={{ paddingLeft: 25 }} selected={currentLocation === 'gateways'} button key={'gateways'} onClick={() => this.onItemClick('gateways')}>
              <ListItemIcon className={classes.drawerIcon}><Apps style={{ fontSize: 18, color: currentLocation === 'gateways' ? '#3f3f3f' : 'inherit' }}/></ListItemIcon>
              <ListItemText
                  primary={
                    <h3
                      className={classes.drawerText}
                      style={{ fontWeight: currentLocation === 'gateways' ? 'bold' : 'normal'}}
                    >
                      <ReduxLanguage languageKey='gateways.gatewaysDevices' />
                    </h3>
                  }
                />
            </ListItem>
            <ListItem style={{ paddingLeft: 25 }} selected={currentLocation === 'gatewaysArtifacts'} button key={'gatewaysArtifacts'} onClick={() => this.onItemClick('gatewaysArtifacts')}>
              <ListItemIcon className={classes.drawerIcon}><BlurCircular style={{ fontSize: 20, color: currentLocation === 'gatewaysArtifacts' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'gatewaysArtifacts' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='gateways.gatewaysArtifacts' />
                  </h3>
                }
              />
            </ListItem>
            <ListItem style={{ paddingLeft: 25 }} selected={currentLocation === 'gatewaysDeployments'} button key={'gatewaysDeployments'} onClick={() => this.onItemClick('gatewaysDeployments')}>
              <ListItemIcon className={classes.drawerIcon}><Share style={{ fontSize: 20, color: currentLocation === 'gatewaysDeployments' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'gatewaysDeployments' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='gateways.gatewaysDeployments' />
                  </h3>
                }
              />
            </ListItem>
          </Collapse>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_PRICELIST}>
            <ListItem button key={'parameters'} onClick={() => this.onTogglePriceListMenu()}>
              <ListItemIcon className={classes.drawerIcon}><PriceListIcon style={{ fontSize: 20 }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                  >
                    <ReduxLanguage languageKey='credits.systemParameters' />
                  </h3>
                }
              />
              {priceListMenuOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
          </Permission>
          <Collapse in={priceListMenuOpen} timeout="auto" unmountOnExit>
            <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_MARKETPLACES}>
                <ListItem style={{ paddingLeft: 25 }} selected={currentLocation === 'marketplaces'} button key={'marketplaces'} onClick={() => this.onItemClick('marketplaces')}>
                  <ListItemIcon className={classes.drawerIcon}><MarketplacesIcon style={{ fontSize: 20, color: currentLocation === 'marketplaces' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
                  <ListItemText
                    primary={
                      <h3
                        className={classes.drawerText}
                        style={{ fontWeight: currentLocation === 'marketplaces' ? 'bold' : 'normal'}}
                      >
                        <ReduxLanguage languageKey='credits.marketplaces' />
                      </h3>
                    }
                  />
                </ListItem>
            </Permission>
            <ListItem style={{ paddingLeft: 25 }} selected={currentLocation === 'subscriptions'} button key={'subscriptions'} onClick={() => this.onItemClick('subscriptions')}>
              <ListItemIcon className={classes.drawerIcon}><SubscriptionsIcon style={{ fontSize: 20, color: currentLocation === 'subscriptions' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'subscriptions' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='credits.systemSubscriptions' />
                  </h3>
                }
              />
            </ListItem>
            <ListItem style={{ paddingLeft: 25 }} selected={currentLocation === 'products'} button key={'products'} onClick={() => this.onItemClick('products')}>
              <ListItemIcon className={classes.drawerIcon}><ProductIcons style={{ fontSize: 20, color: currentLocation === 'products' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'products' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='credits.products' />
                  </h3>
                }
              />
            </ListItem>
          </Collapse>
          {/* <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_SALESINFO}>
            <ListItem selected={currentLocation === 'hardwareSalesInfo'} button key="hardwareSalesInfo" onClick={() => this.onItemClick('hardwareSalesInfo')}>
              <ListItemIcon className={classes.drawerIcon}><GridOnOutlined style={{ fontSize: 18, color: currentLocation === 'hardwareSalesInfo' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'hardwareSalesInfo' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='sales.hardwareSalesInfo' />
                  </h3>
                }
              />
            </ListItem>
          </Permission> */}
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_PRODUCTINFO}>
            <ListItem selected={currentLocation === 'productInfo'} button key={'productInfo'} onClick={() => this.onItemClick('productInfo')}>
              <ListItemIcon className={classes.drawerIcon}><ContactSupportIcon style={{ fontSize: 20, color: currentLocation === 'productInfo' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'productInfo' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='vars.varInfoPage' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_DEVELOPERS_RESOURCES}>
            <ListItem selected={currentLocation === 'developersResource'} button key={'developersResource'} onClick={() => this.onItemClick('developersResource')}>
              <ListItemIcon className={classes.drawerIcon}><CodeOutlined style={{ fontSize: 20, color: currentLocation === 'developersResource' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'developersResource' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='developers.developersResource' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_VAR_USERS}>
            <ListItem selected={currentLocation === 'varusers'} button key={'varusers'} onClick={() => this.onItemClick('varusers')}>
              <ListItemIcon className={classes.drawerIcon}><VerifiedUserOutlinedIcon style={{ fontSize: 20, color: currentLocation === 'varusers' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'varusers' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='users.usersManagement' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_VAR_SETTINGS}>
            <ListItem selected={currentLocation === 'varSettings'} button key={'varSettings'} onClick={() => this.onItemClick('varSettings')}>
              <ListItemIcon className={classes.drawerIcon}><SettingsOutlined style={{ fontSize: 20, color: currentLocation === 'varSettings' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'varSettings' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='vars.varSettings' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_VAR_USER_MANUAL}>
            <ListItem selected={currentLocation === 'vashoManual'} button key={'vashoManual'} onClick={() => this.onItemClick('vashoManual')}>
              <ListItemIcon className={classes.drawerIcon}><HelpOutline style={{ fontSize: 20 }}/></ListItemIcon>
              <ListItemText primary={<h3
                className={classes.drawerText}
                style={{ fontWeight: currentLocation === 'vashoManual' ? 'bold' : 'normal'}}
              >
                <ReduxLanguage languageKey='vars.vashoManual' />
              </h3>
              } />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_PLATFORM_USERS}>
            <ListItem selected={currentLocation === 'users'} button key={'users'} onClick={() => this.onItemClick('users')}>
              <ListItemIcon className={classes.drawerIcon}><VerifiedUserOutlinedIcon style={{ fontSize: 20, color: currentLocation === 'users' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'users' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='users.usersManagement' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.NAVIGATION_SETTINGS}>
            <ListItem selected={currentLocation === 'settings'} button key={'settings'} onClick={() => this.onItemClick('settings')}>
              <ListItemIcon className={classes.drawerIcon}><TuneOutlined style={{ fontSize: 20, color: currentLocation === 'settings' ? '#3f3f3f' : 'inherit' }} /></ListItemIcon>
              <ListItemText
                primary={
                  <h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'settings' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='settings.title' />
                  </h3>
                }
              />
            </ListItem>
          </Permission>
          <ListItem selected={currentLocation === 'status'} button key={'status'} onClick={() => this.onItemClick('status')}>
            <ListItemIcon className={classes.drawerIcon}><InfoOutlined style={{ fontSize: 20 }}/></ListItemIcon>
            <ListItemText primary={<h3
                    className={classes.drawerText}
                    style={{ fontWeight: currentLocation === 'users' ? 'bold' : 'normal'}}
                  >
                    <ReduxLanguage languageKey='domains.verifyServiceStatus' />
                  </h3>
                } />
          </ListItem>
        </List>
      </div>
    );
    return (
    <div>
      <AppHeader
        handleDrawerToggle={() => this.handleDrawerToggle()}
      />
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor="left"
            open={mobileOpen}
            onClose={() => this.handleDrawerToggle()}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawerContent}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            <Toolbar />
            {drawerContent}
          </Drawer>
        </Hidden>
      </nav>
      <div className={classes.contentWithDrawer}>
        {children}
      </div>
    </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    userEmail: state.user.userData?.user_name || '',
  };
}

const connector = connect(mapStateToProps);
export default connector(withRouter(withStyles(styles)(DrawerLayout)));